import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { Tooltip } from "antd";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { FaQuestionCircle } from "react-icons/fa";
import {
	traerDatos,
	HeadersAuth,
	CheckExpiracion,
	traerDatosObjeto,
} from "../funciones_utiles";
import {
	validarSoloTexto,
	validarEmail,
	validarTextoNumerico,
    validarPassword
} from "../validaciones";

const MySwal = withReactContent(Swal);

// const MemoizedChartEmisionesMulti = React.memo(ChartEmisionesMulti);
//DESCARGAR MOMENT JS
export const FormularioPassCambio = ({ sesion , cerrarModal}) => {

	const [tempDatosPreCambio, setTempDatosPreCambio] = useState({});
	const URI =
		process.env.REACT_APP_DOMINIO + process.env.REACT_APP_PUERTO + "/new_password";
	// useEffect(() => {
	// 	if (sesion.pre_cambio) {
	// 		(async () => {
	// 			const datosConsumo = await traerDatosObjeto(URI);
    //             // console.log(await traerDatosObjeto(URI))
	// 			setTempDatosPreCambio(datosConsumo);
	// 		})();
	// 	} else {
			
	// 	}
	// }, [URI]);

	var [tooltipVisible, setTooltipVisible] = useState({
		oldPassword: false,
		newPassword: false,
        newPasswordCopia: false
	});
	const [errores, setErrores] = useState({
		oldPassword: "",
		newPassword: "",
		newPasswordCopia: "",
	});
	const campos = [
		{ name: "oldPassword", validator: validarPassword },
		{ name: "newPassword", validator:  validarPassword},
		{ name: "newPasswordCopia", validator: validarPassword },

	];


	const handleChange = async (e) => {
		const { id, value } = e.target;
		// console.log("ES : " + value);

		setTempDatosPreCambio({
			...tempDatosPreCambio,
			[id]: value,
		});

		let erroresTemp = { ...errores };
		const validarCampo = async (campo, valor) => {
			const resultadoValidacion = await campo(valor);
			return {
				mensaje: resultadoValidacion.mensaje,
				valido: resultadoValidacion.valido,
			};
		};
		const campoActual = campos.find((campo) => campo.name === id);

		if (campoActual) {
			const mira = await validarCampo(campoActual.validator, value);
			erroresTemp[id] = mira.mensaje;
			setTooltipVisible((prevState) => ({
				...prevState,
				[id]: !mira.valido,
			}));
			setTimeout(() => {
				setTooltipVisible((prevState) => ({
					...prevState,
					[id]: false,
				}));
			}, 3000);
		}

		setErrores(erroresTemp);
	};

	const guardar = async (e) => {
		e.preventDefault();
		let hayErrores = false;
		const erroresTemp = {};
        if(tempDatosPreCambio.newPassword === tempDatosPreCambio.newPasswordCopia ){
            for (const campo of campos) {
                const valorCampo = String(tempDatosPreCambio[campo.name]);
                const resultadoValidacion = await campo.validator(
                    valorCampo,
                    tooltipVisible
                );
    
                if (resultadoValidacion.valido === false) {
                    hayErrores = true;
                    erroresTemp[campo.name] = resultadoValidacion.mensaje;
                    setTooltipVisible((prevState) => ({
                        ...prevState,
                        [campo.name]: !resultadoValidacion.valido,
                    }));
                    setTimeout(() => {
                        setTooltipVisible((prevState) => ({
                            ...prevState,
                            [campo.name]: false,
                        }));
                    }, 3000);
                }
            }
            if (hayErrores) {
                setErrores(erroresTemp);
                return;
            } else {
    
                
                    let cambio = await axios.post(
                        URI,
                        tempDatosPreCambio,
                        HeadersAuth
                    );
                
    console.log(cambio)
                if (cambio.data.code === 409) {
                    CheckExpiracion();
                } else {
                    if (cambio.data.code === 200) {
                        MySwal.fire({
                            html: "Guardado con éxito",
							icon: "success",
                            imageHeight: 65,
                            confirmButtonText: "Ok",
							customClass: {
								confirmButton: "btn-confirmar",
							  },
						}).then(() => {
							window.location.reload();
						  });
                       
                        cerrarModal(false)
                        setTempDatosPreCambio({
                            oldPassword: "",
                            newPassword: "",
                            newPasswordCopia: ""
                        });
                    }
                }
            }
        }else{
            MySwal.fire({
                html: "Las contraseñas no coinciden",
				icon: "error",
                imageHeight: 65,
                confirmButtonText: "Ok",
				customClass: {
					confirmButton: "btn-confirmar",
				  },
            });
        }
		
	};

	return (
		<>
			<form onSubmit={guardar}>
				<label className="label-datos" htmlFor="oldPassword">
				Contraseña actual
				</label>
				<Tooltip
					title={!!errores.oldPassword && <span>{errores.oldPassword}</span>}
					open={tooltipVisible.oldPassword}
					color="#1CA6AF">
					<input
						className="input-login"
						type="password"
						placeholder={"Contraseña actual"}
						id="oldPassword"
						value={tempDatosPreCambio.oldPassword || ""}
						onChange={handleChange}
					/>
				</Tooltip>
                <br></br>
                <label className="label-datos" htmlFor="newPassword">
					Nueva Contraseña
				</label>
				<Tooltip
					title={!!errores.newPassword && <span>{errores.newPassword}</span>}
					open={tooltipVisible.newPassword}
					color="#1CA6AF">
					<input
						className="input-login"
						type="password"
						placeholder={"Nueva contraseña"}
						id="newPassword"
						value={tempDatosPreCambio.newPassword || ""}
						onChange={handleChange}
					/>
				</Tooltip>
                <br></br>

                <label className="label-datos" htmlFor="newPasswordCopia">
                    Repita su nueva Contraseña
				</label>
				<Tooltip
					title={!!errores.newPasswordCopia && <span>{errores.newPasswordCopia}</span>}
					open={tooltipVisible.newPasswordCopia}
					color="#1CA6AF">
					<input
						className="input-login"
						type="password"
						placeholder={"Nueva contraseña"}
						id="newPasswordCopia"
						value={tempDatosPreCambio.newPasswordCopia || ""}
						onChange={handleChange}
					/>
				</Tooltip>
              
				<button
					className="btn-login"
					style={{ marginTop: "1rem" }}>
					Guardar
				</button>
			</form>
		</>
	);
};
